export const isLocalhost = () => /localhost/.test(document.location.href);



// WEBPACK FOOTER //
// ./src/config/getServiceUrls.js